import fastq from 'fastq';

export const Delay = (time: number) => {
  return new Promise((resolve) => setTimeout(resolve, time));
};

export const SecondToMs = (second: number) => (isNaN(second) ? second : second * 1000);

const asyncWorker = async (func: Function): Promise<unknown> => {
  const result = func();
  return result;
};

export const queue = fastq.promise(asyncWorker, 1);

export const controlledTimeout = (callback: () => void, delay: number) => {
  let timeoutId;

  function start() {
    timeoutId = setTimeout(() => {
      callback();
      start();
    }, delay);
  }

  function restart() {
    clearTimeout(timeoutId);
    start();
  }

  start();

  return {
    restart,
    clear: () => clearTimeout(timeoutId),
  };
};
